export enum FontAwesomeIcon {
  AngleDown = 'angle-down',
  AngleLeft = 'angle-left',
  AngleRight = 'angle-right',
  AngleUp = 'angle-up',
  ArrowLeft = 'arrow-left',
  ArrowRight = 'arrow-right',
  Bars = 'bars',
  Calendar = 'calendar',
  CartShopping = 'cart-shopping',
  Check = 'check',
  CircleExclamation = 'circle-exclamation',
  CircleQuestion = 'circle-question',
  CircleUser = 'circle-user',
  Clock = 'clock',
  FaceFrown = 'face-frown',
  House = 'house',
  MagnifyingGlass = 'magnifying-glass',
  Minus = 'minus',
  Plus = 'plus',
  RocketLaunch = 'rocket-launch',
  ShareNodes = 'share-nodes',
  Ticket = 'ticket',
  Trash = 'trash',
  User = 'user',
  Users = 'users',
  Xmark = 'xmark',
}
